export default __webpack_public_path__ + "static/media/Banner_image_Kaapse_small.535e954b.jpg";